export const APP_STRINGS = {
  APP_NAME: "Johukum Admin",
};

export const PAGE_TITLES = {
  DASHBOARD: "Dashboard",
  BOOKINGS: "Bookings",
  USERS: "Users",
};

export const MENU_STRINGS = {
  DASHBOARD: "Dashboard",
  BOOKINGS: "Bookings",
  USERS: "Users",

  NOTIFICATIONS: "Notifications",
  REPORTS: "Reports",
  PAYMENTS: "Payments",
  SERVICES: "Services",

  LOGOUT: "Logout",
};

export const MESSAGES = {
  SOMETHING_WENT_WRONG: "Something went wrong",
  NO_DATA_FOUND: "No data found",
  PAGE_NOT_FOUND: "Page Not Found",
};

export const AUTH_STRINGS = {
  LOGIN_TITLE: "Johukum Admin Portal",
  SUBTITLE: "Sign in to manage your service platform",

  PHONE_PLACEHOLDER: "Phone Number",
  OTP_PLACEHOLDER: "Enter OTP",

  SEND_OTP: "Send OTP",
  VERIFY_OTP: "Verify OTP",

  ENTER_PHONE_ERROR: "Please enter phone number",
  INVALID_OTP: "Invalid OTP",

  PHONE_REQUIRED: "Phone number is required",
  OTP_REQUIRED: "OTP is required",
  LOGIN_SUCCESS: "Login successful",
};

export const DASHBOARD_STRINGS = {
  TOTAL_USERS: "Total Users",
  TOTAL_BOOKINGS: "Total Bookings",
  PENDING: "In-Progress",
  COMPLETED: "Completed",

  ANALYTICS_OVERVIEW: "Analytics Overview",
  USER_METRICS: "User Metrics",
  DISTRIBUTION: "Distribution",
};

export const BOOKING_STRINGS = {
  TITLE: "Booking List",
  SEARCH_PLACEHOLDER: "Search bookings...",
  FILTER_STATUS: "Filter by status",

  BOOKING_ID: "Booking ID",
  USER: "User",
  SERVICE: "Service",
  DATE: "Date",
  STATUS: "Status",
  ACTIONS: "Actions",

  COMPLETE: "Complete",
  CANCEL: "Cancel",

  CONFIRM_CANCEL_TITLE: "Cancel Booking",
  CONFIRM_CANCEL_DESC: "Are you sure you want to cancel this booking?",
  CONFIRM: "Confirm",
  CLOSE: "Close",
};
export const USER_LIST_STRINGS = {
  title: "Users",
  searchPlaceholder: "Search users...",
  active: "Active",
  blocked: "Blocked",
  view: "View",
  block: "Block",
  unblock: "Unblock",
};
export const NOTIFICATION_STRINGS = {
  TITLE: "Notifications",
  SEARCH_PLACEHOLDER: "Search notifications...",
  FILTER_TYPE: "All Types",

  TYPE_INFO: "Info",
  TYPE_SUCCESS: "Success",
  TYPE_WARNING: "Warning",

  STATUS_READ: "Read",
  STATUS_UNREAD: "Unread",

  MARK_READ: "Mark Read",

  COLUMN_TITLE: "Title",
  COLUMN_TYPE: "Type",
  COLUMN_DATE: "Date",
  COLUMN_STATUS: "Status",
  COLUMN_ACTIONS: "Actions",
};
export const REPORT_STRINGS = {
  TITLE: "Reports",
  SEARCH_PLACEHOLDER: "Search reports...",
  FILTER_TYPE: "All Types",

  TYPE_BOOKING: "Booking",
  TYPE_USER: "User",
  TYPE_PAYMENT: "Payment",

  STATUS_READY: "Ready",
  STATUS_PENDING: "Pending",

  DOWNLOAD: "Download",
  VIEW: "View",

  COLUMN_ID: "Report ID",
  COLUMN_NAME: "Name",
  COLUMN_PHONE: "Phone",
  COLUMN_DATE: "Date",
  COLUMN_STATUS: "Status",
  COLUMN_ACTIONS: "Actions",
};

export const PAYMENT_STRINGS = {
  TITLE: "Payments",
  SEARCH_PLACEHOLDER: "Search payments...",
  FILTER_STATUS: "All Status",

  STATUS_SUCCESS: "Success",
  STATUS_PENDING: "Pending",
  STATUS_FAILED: "Failed",

  COLUMN_ID: "Payment ID",
  COLUMN_USER: "User",
  COLUMN_AMOUNT: "Amount",
  COLUMN_METHOD: "Method",
  COLUMN_DATE: "Date",
  COLUMN_STATUS: "Status",
  COLUMN_ACTIONS: "Actions",

  VIEW: "View",
};

export const COMMON_STRINGS = {
  SOMETHING_WENT_WRONG: "Something went wrong",
  SERVER_ERROR: "Server error, please try again",
  NETWORK_ERROR: "Network error, check your internet",
  UNAUTHORIZED: "Session expired, please login again",
  FORBIDDEN: "You are not allowed to perform this action",
  NOT_FOUND: "Resource not found",
  NO_DATA_FOUND: "No data found",
};

export const STATUS_CONFIG = {
  // 🔸 BOOKING
  PENDING: {
    value: "pending",
    label: "Pending",
    bg: "var(--warning-soft)",
    color: "var(--warning)",
  },

  CONFIRMED: {
    value: "confirmed",
    label: "Confirmed",
    bg: "var(--blue-soft)",
    color: "var(--blue)",
  },

  COMPLETED: {
    value: "completed",
    label: "Completed",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },

  CANCELLED: {
    value: "cancelled",
    label: "Cancelled",
    bg: "var(--danger-soft)",
    color: "var(--danger)",
  },

  // 🔸 SUPPORT
  OPEN: {
    value: "open",
    label: "Open",
    bg: "var(--warning-soft)",
    color: "var(--warning)",
  },

  IN_PROGRESS: {
    value: "in_progress",
    label: "In Progress",
    bg: "var(--blue-soft)",
    color: "var(--blue)",
  },

  RESOLVED: {
    value: "resolved",
    label: "Resolved",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },

  // 🔸 USER
  ACTIVE: {
    value: "active",
    label: "Active",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },

  BLOCKED: {
    value: "blocked",
    label: "Blocked",
    bg: "var(--danger-soft)",
    color: "var(--danger)",
  },

  //Payment
  PAID: {
    value: "paid",
    label: "Paid",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },
// 🔸 NOTIFICATION (🔥 NEW ADD)
  READ: {
    value: "read",
    label: "Read",
    bg: "var(--success-soft)",
    color: "var(--success)",
  },

  UNREAD: {
    value: "unread",
    label: "Unread",
    bg: "var(--warning-soft)",
    color: "var(--warning)",
  },
};